import { useReportBuilderStore } from '../../stores/reportBuilderStore';
import { Table, ChartBar } from '@phosphor-icons/react';
import { ChartTypeSelector } from '@t-one-internal/design-system';
import type { ReportChartType } from '../../types/reportBuilder';

const ALLOWED_CHART_TYPES: ReportChartType[] = ['bar', 'column', 'line', 'area', 'pie', 'donut', 'radar'];

export default function ResultsViewToggle() {
  const { viewMode, chartType, setViewMode, setChartType, autoDetectFieldMapping, autoDetectPivotConfig } = useReportBuilderStore();

  const handleChartMode = () => {
    if (viewMode !== 'chart') {
      autoDetectFieldMapping();
      setViewMode('chart');
    }
  };

  return (
    <div className="flex items-center gap-2">
      <div className="inline-flex rounded-md border border-gray-300 bg-white">
        <button
          onClick={() => setViewMode('table')}
          className={`flex items-center gap-1.5 rounded-l-md px-3 py-1.5 text-sm font-medium transition-colors ${
            viewMode === 'table' ? 'bg-primary text-white' : 'text-gray-600 hover:bg-gray-50'
          }`}
        >
          <Table className="h-4 w-4" /> Table
        </button>
        <button
          onClick={() => { autoDetectPivotConfig(); setViewMode('pivot'); }}
          className={`flex items-center gap-1.5 border-x border-gray-300 px-3 py-1.5 text-sm font-medium transition-colors ${
            viewMode === 'pivot' ? 'bg-primary text-white' : 'text-gray-600 hover:bg-gray-50'
          }`}
        >
          <Table className="h-4 w-4" /> Pivot
        </button>
        <button
          onClick={handleChartMode}
          className={`flex items-center gap-1.5 rounded-r-md px-3 py-1.5 text-sm font-medium transition-colors ${
            viewMode === 'chart' ? 'bg-primary text-white' : 'text-gray-600 hover:bg-gray-50'
          }`}
        >
          <ChartBar className="h-4 w-4" /> Chart
        </button>
      </div>

      {viewMode === 'chart' && (
        <ChartTypeSelector
          currentChartType={chartType}
          allowedChartTypes={ALLOWED_CHART_TYPES}
          onChartTypeChange={(type) => setChartType(type as ReportChartType)}
        />
      )}
    </div>
  );
}
